import { DirectoryIntro } from '~/ui-rocco/pages/directory-browse/DirectoryIntro';
import { VerticalWordmark } from '~/ui-rocco/pages/directory-browse/DirectoryBrowsePage';
import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { DIRECTORY_GUTTER_X } from './EditorialArticleGrid';
import { EditorialSubscribeRail } from './EditorialSubscribeRail';

/**
 * How the category rail sits on the paper: on the listing's own measure, its
 * band frosted in the page's colour, only the active pill filled, and the
 * rule under it in that pill's ink. One set for the directory and every theme
 * page, so moving between them changes the active pill and nothing else.
 */
export const EDITORIAL_RAIL = {
    // The grid's px-4 below md, so the search glyph leading the row lands on
    // the 16px page gutter the way the category pages' refine control does.
    gutterClassName: 'px-4 md:px-[max(3rem,calc((100%_-_1920px)/2_+_3rem))]',
    bandClassName: 'md:bg-white/70',
    inactivePillClassName:
        'bg-transparent text-[#323232] hover:bg-black/5 active:bg-black/10',
    ruleClassName: 'border-[#323232]',
} as const;

/**
 * The editorial pages' opening, as the category pages open: the library's
 * name as a watermark behind the header, then the statement with the
 * subscribe rail beside it where the other directories put Get Matched, all
 * in the editorial serif.
 *
 * The directory and every theme page draw exactly this, with the same
 * statement, so clicking a tab changes the tab and the grid under it and
 * nothing above moves.
 */
export const EditorialDirectoryOpening = ({
    statement,
}: {
    /** The directory's statement — the same one on every editorial page. */
    statement: string;
}) => (
    <>
        {/* The same offset the light browse page gives the mark, because the
            header above is the same header. Set well into the paper: a mark
            off-white on the grey pages, but on the cream it has to be a good
            few steps darker to survive the blur. */}
        <VerticalWordmark
            isDark={false}
            title="Articles"
            className="-top-[9.1rem]"
            markClassName="font-gestura font-normal text-[#e1ddd6]"
        />
        <SectionSpacer height={128} mobileHeight={38} unit="rem" />
        <section
            data-section="intro"
            // On the listing's own measure, so the statement, the rail under
            // it and the cards share one left edge.
            className={DIRECTORY_GUTTER_X}
        >
            <DirectoryIntro
                eyebrow="Articles Library"
                heading={statement}
                entryPoint="CategoryLead"
                statementClassName="font-gestura md:font-normal"
                // Wide enough that the sentence sits on two lines.
                statementMeasureClassName="md:max-w-[72rem]"
                rail={<EditorialSubscribeRail />}
            />
        </section>
        {/* With the publications' own 65px above them, 77px between the
            statement and the covers. */}
        <SectionSpacer height={12} mobileHeight={40} unit="rem" />
    </>
);
